import "./FilterSidebar.scss"

import React, { useState } from "react"
import { classSet } from "@fider/services"
import { Icon } from "@fider/components"
import IconX from "@fider/assets/images/heroicons-x.svg"
import IconMenu from "@fider/assets/images/heroicons-menu.svg"
import { VStack } from "@fider/components/layout"

interface FilterSidebarProps {
  title: string
  children: React.ReactNode
}

// Persistent left sidebar, modeled on the admin SideMenu — hidden below `lg`
// (revealed via FilterSidebarToggler), always visible at `lg`+ so multiple
// selections don't require reopening a popup.
export const FilterSidebar = (props: FilterSidebarProps) => {
  return (
    <div className="js-filter-sidebar sm:hidden md:hidden lg:block">
      <VStack spacing={0} className="c-filter-sidebar rounded-md shadow bg-white">
        <div className="c-filter-sidebar__title">{props.title}</div>
        {props.children}
      </VStack>
    </div>
  )
}

// Hamburger toggle for the sidebar below `lg` — mirrors SideMenuToggler's
// imperative class-toggling approach exactly (same technique, separate
// target class so both can coexist on different pages without collision).
export const FilterSidebarToggler = () => {
  const [isActive, setIsActive] = useState(false)

  const toggle = () => {
    const classes = ["sm:hidden", "md:hidden"]
    const el = document.querySelector(".js-filter-sidebar") as HTMLElement
    if (el && !isActive) {
      el.classList.remove(...classes)
    } else if (el && isActive) {
      el.classList.add(...classes)
    }
    setIsActive(!isActive)
  }

  return (
    <div className="h-8 w-8 lg:hidden xl:hidden" onClick={toggle}>
      {isActive ? <Icon sprite={IconX} /> : <Icon sprite={IconMenu} />}
    </div>
  )
}

interface FilterSidebarItemProps {
  label: string
  isActive: boolean
  color?: string
  onClick: () => void
}

// A single-select nav-style entry (e.g. one product), styled like
// SideMenuItem's active/inactive states, with an optional color dot.
export const FilterSidebarItem = (props: FilterSidebarItemProps) => {
  const className = classSet({
    "c-filter-sidebar__item": true,
    "c-filter-sidebar__item--active": props.isActive,
  })

  return (
    <div className={className} onClick={props.onClick}>
      {props.color && <span className="c-filter-sidebar__dot" style={{ backgroundColor: `#${props.color}` }} />}
      {props.label}
    </div>
  )
}

export const FilterSidebarSectionTitle = (props: { children: React.ReactNode }) => <div className="c-filter-sidebar__section-title">{props.children}</div>
